/* Deactivated */

import { DETAILS_CONTENT_KEYS, IPlanContent, KeyDetailsItem, MarkdownItem } from '../typings';
import { createPlanNameMatcher, getKeyDetailsContentIcon } from './utils/PlanMetaHelper';
import { PlanKeyDetailsModal } from './common/PlanKeyDetailsModal';
import { defaultEstimatesDialog } from './common/planDefaults';

const PLAN_TONE = 'promote';

const defaultKeyDetails: KeyDetailsItem[] = [
  {
    contentKey: DETAILS_CONTENT_KEYS.Rates,
    contentValue: 'Variable',
    modalContent: PlanKeyDetailsModal,
    contentIcon: getKeyDetailsContentIcon(DETAILS_CONTENT_KEYS.Rates),
    contentDescription: 'Variable rates',
  },
  {
    contentKey: DETAILS_CONTENT_KEYS.ExitFees,
    contentValue: 'No',
    contentIcon: getKeyDetailsContentIcon(DETAILS_CONTENT_KEYS.ExitFees),
    contentDescription: 'No exit fees. Leave anytime.',
  },
  {
    contentKey: DETAILS_CONTENT_KEYS.BenefitPeriod,
    contentValue: '12 months, No lock ins',
    contentIcon: getKeyDetailsContentIcon(DETAILS_CONTENT_KEYS.BenefitPeriod),
    contentDescription: '12 month benefit period',
  },
];

const defaultKeyFeatures: (string | MarkdownItem)[] = [
  {
    isMarkDown: true,
    content: 'Rates - Variable',
    modalContent: PlanKeyDetailsModal,
    modalTitle: 'Rates - Variable',
  },
  'No Exit fees',
  'Benefit period - 12 months, No lock ins',
];

export const greenerForBusiness: IPlanContent = {
  test: createPlanNameMatcher(['"Greener for Business" Variable']),
  content: {
    rateDiscountText: {
      defaultState: {
        defaultFuel: 'Rates variable on a 12 month benefit period',
      },
    },
    keyFeatures: {
      defaultState: {
        defaultFuel: defaultKeyFeatures,
        dual: [
          ...defaultKeyFeatures,
          '100% GreenPower and 100% Origin Go Zero Natural Gas included in the plan',
        ],
        electricity: [...defaultKeyFeatures, '25% GreenPower included in the plan'],
        gas: [...defaultKeyFeatures, 'Origin Go Zero Natural Gas included in the plan'],
      },
    },
    keyDetails: {
      defaultState: {
        defaultFuel: defaultKeyDetails,
        dual: [
          ...defaultKeyDetails,
          {
            contentKey: DETAILS_CONTENT_KEYS.Addons,
            contentValue: '25% GreenPower and 100% Origin Go Zero Natural Gas included in the plan',
            contentIcon: getKeyDetailsContentIcon(DETAILS_CONTENT_KEYS.Addons),
            contentDescription:
              '25% GreenPower and 100% Origin Go Zero Natural Gas included in the plan',
          },
        ],
        electricity: [
          ...defaultKeyDetails,
          {
            contentKey: DETAILS_CONTENT_KEYS.Addons,
            contentValue: '25% GreenPower included in the plan',
            contentIcon: getKeyDetailsContentIcon(DETAILS_CONTENT_KEYS.Addons),
            contentDescription: '25% GreenPower included in the plan',
          },
        ],
        gas: [
          ...defaultKeyDetails,
          {
            contentKey: DETAILS_CONTENT_KEYS.Addons,
            contentValue: 'Origin Go Zero Natural Gas included in the plan',
            contentIcon: getKeyDetailsContentIcon(DETAILS_CONTENT_KEYS.Addons),
            contentDescription: 'Origin Go Zero Natural Gas included in the plan',
          },
        ],
      },
    },
    keyDetailsAddons: {
      defaultState: {
        defaultFuel: [],
      },
    },
    onlineCredits: undefined,
    uiOptions: {
      defaultState: {
        defaultFuel: {
          planColor: {
            text: {
              styleGuide: 'green',
              odsCore: PLAN_TONE,
            },
            promobox: {
              styleGuide: 'green',
              odsCore: PLAN_TONE,
            },
            bannerText: {
              styleGuide: 'white',
              odsCore: 'white',
            },
          },
        },
      },
    },
    estimatesDialog: defaultEstimatesDialog(),
  },
};
